import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { CtaBlock } from '../CtaBlock';
import { familiarSituations } from '../../data/content';
export function ForYouSection() {
  return <section className="bg-navy-50 py-14 sm:py-20" aria-labelledby="foryou-title" data-id="element-164" data-mp="nspk5yqpjlzx">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-165" data-mp="it347hjhvrnf">
        <SectionHeading eyebrow="Is this for you?" title={<span id="foryou-title" data-id="element-167" data-mp="3r9xyi8m883pw">Do any of these situations sound familiar?</span>} subtitle="If you answer yes to two or more, this system was designed for you." data-id="element-166" data-mp="itw3xyk1dgw2" />

        <ul className="mt-9 grid gap-3 sm:grid-cols-2" data-id="element-168" data-mp="4ttr4qql5dno">
          {familiarSituations.map(situation => <li key={situation.text} className="flex items-start gap-3 rounded-2xl border border-navy-100 bg-white p-4 sm:p-5" data-id="element-169" data-mp="2bm9rlfysxf">
              <span className="text-xl leading-none" aria-hidden="true" data-id="element-170" data-mp="33jbq2g8b8hfd">
                {situation.icon}
              </span>
              <span className="text-[14px] font-medium leading-snug text-navy-800 sm:text-[15px]" data-id="element-171" data-mp="ar4oxsuijybc">
                {situation.text}
              </span>
            </li>)}
        </ul>

        <div className="mt-10 rounded-3xl border-l-4 border-clinic-500 bg-white p-5 sm:p-7" data-id="element-172" data-mp="kfwdrs4a22i1">
          <p className="text-base font-black text-navy-900 sm:text-lg" data-id="element-173" data-mp="oi9gs8rn3mb4">
            This is where everything changes.
          </p>
          <p className="mt-3 text-pretty text-[15px] leading-relaxed text-navy-700 sm:text-base" data-id="element-174" data-mp="3ny6eh2m9it51">
            Instead of trying to memorize hundreds of recommendations, you’ll have a system that
            organizes clinical decisions in the same order they actually happen during a
            consultation.
          </p>
          <ul className="mt-4 space-y-2 text-[14px] font-semibold text-navy-800 sm:text-[15px]" data-id="element-175" data-mp="5p5ksgqy8xdc">
            <li data-id="element-176" data-mp="1c9eykth54oo2">• Every algorithm answers a specific question.</li>
            <li data-id="element-177" data-mp="1h540v4kjojo2">• Every volume solves a specific stage of patient management.</li>
            <li data-id="element-178" data-mp="3d8sbe491judp">• Every tool helps you make decisions with greater speed and confidence.</li>
          </ul>
        </div>

        <CtaBlock kicker="Replace memory with a method you can apply today." label="👉 I want to apply the method now" data-id="element-179" data-mp="3976qpwq9mbsy" />
      </div>
    </section>;
}